<template>
  <app-modal @closeModal="closeModal" class="click-outside-categories-ignore" :containerClass="`${$attrs.addOverflow ? 'overflow-visible-important' : '' }${$attrs.large ? ' modal-lg' : ''} ${$attrs.customWrapperCss}`">
    <div slot="header">
      <h3 class="text-truncate">{{ $t(title, [nameLabel]) }} 
        <template v-if="subtitle">- {{ subtitle }}</template>
      </h3>
      <div v-if="icon" class="download-link">
        <a 
          href="/excel/import_template.xlsx" 
          class="text-orange" 
          target="_blank"
          download="import_template.xlsx"
        ><i :class="icon"></i> {{iconTitle}}</a>
      </div>
    </div>
    <div slot="body">
      <slot name="topArea"></slot>
      <app-loader v-if="loading" class="p60" />
      <app-form-renderer
          v-else
          :id="$attrs.id"
          :model="$attrs.model"
          :fieldsObjects="$attrs.fieldsObjects"
          :fields="$attrs.fields"
          :fieldsAdditions="$attrs.fieldsAdditions || {}"
          :formGroupClass="$attrs.formGroupClass || ''"
          :errors="errors || []"
          :errors-type="errorsType"
          :submitButtonLabel="submitButtonLabel"
          cancelButtonLabel="form.button.close"
          :disableSubmit="disableSubmit"
          :show-delete="showDelete"
          :showSaveAs="$attrs.showSaveAs"
          :showCancel="true"
          :customValidators="customValidators"
          :showFooterBorderTop="$attrs.showFooterBorderTop"
          @onSave="save"
          @onDelete="deleteRecord"
          @onCancel="closeModal"
          @updateModel="updateModel"
          @onSearchChangeInput="onSearchChangeInput"
      />
      <slot name="bottomArea"></slot>
    </div>
  </app-modal>
</template>

<script>
  import Modal from './modal';
  import FormRenderer from './form-renderer';
  import Loader from './loader';

  export default {
    props: {
      title: {
        type: String,
        default: 'outlets.add_outlet_header'
      },
      subtitle: {
        type: String,
        required: false,
        default: ''
      },
      nameLabel: {
        type: String
      },
      submitButtonLabel: {
        type: String,
        default: 'form.button.save'
      },
      errors: {
        type: Array,
        required: false,
        default: () => {
          return [];
        }
      },
      errorsType: {
        type: String,
        required: false,
        default: 'default'
      },
      showDelete: {
        type: Boolean,
        required: false,
        default: false
      },
      customValidators: {
        type: Object,
        required: false,
        default: () => {
          return {};
        }
      },
      icon:{
        type: String,
        required: false,
        default: ''
      },
      iconTitle:{
        type: String,
        required: false,
        default: 'Template'
      },
      loading: {
        type: Boolean,
        default: () => false
      },
      disableSubmit: {
        type: Boolean,
        require: false,
        default: false,
      },
    },
    components: {
      'app-modal': Modal,
      'app-form-renderer': FormRenderer,
      'app-loader': Loader
    },
    methods: {
      closeModal (e) {
        if(e) {
          e.preventDefault();
          e.stopPropagation();
        }

        this.$emit('closeModal');
      },
      save (data, saveAs) {
        if (saveAs) {
          delete data.id;
        }

        this.$emit('onSave', data, saveAs);
      },
      deleteRecord (data) {
        this.$emit('onDelete', data);
      },
      updateModel (model, field) {
        this.$emit('updateModel', model, field)
      },
      onSearchChangeInput (value, field){
        this.$emit('onSearchChangeInput', value, field);
      },
    }
  }
</script>